import { Grid, Typography } from "@mui/material";
import colors from "../../../colors";
import React from "react";

const FinalValueView = ({state, transactionType}) => {
  return (
    <Grid
      container
      item
      md={12}
      xs={12}
      display={state.finalValue === "NaN" || state.finalValue === "" ? "none" : 'align-left'}
      justifyContent={"flex-start"}
      alignItems={"flex-start"}
      flexDirection={"column"}
    >
      <Typography
        sx={{
          color: colors.darkBlue,
          fontSize: "1.3rem",
          fontFamily: "GerberaBold",
        }}
      >
        {state.finalValue}
        {state.exchangeMethod === transactionType.purchase ?
        " ALL" : (' ' + state.currency.name)}
      </Typography>
      <Typography
        sx={{
          color: colors.darkBlue,
          fontSize: "0.8rem",
          fontFamily: "GerberaMedium",
        }}
      >{state.exchangeMethod === transactionType.purchase ?
       ( '1 ' + ( state.currency.name) + ' = ' + ( state.currency.buysFor) + ' ALL'):
       ('1' + ' ALL' + ' = ' + parseFloat(1 / state.currency.sellsFor).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,") + ' ' + (state.currency.name))}
      </Typography>
    </Grid>
  );
};

export default FinalValueView;
